const CheckIcon = () => {
  return (
    <svg
      className='h-6 w-6 text-accent mr-2'
      fill='none'
      viewBox='0 0 24 24'
      stroke='currentColor'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M5 13l4 4L19 7'
      />
    </svg>
  );
};

const Price = () => {
  const offers = [
    'Access to all challenges',
    'Progress tracking',
    'Community support',
    'AI meal tracking',
    'Goal setting tools',
  ];

  return (
    <section
      className='py-20 bg-black text-text-main'
      id='pricing'
    >
      <div className='container mx-auto px-4 max-w-6xl'>
        <div className='text-center mb-16'>
          <h2 className='text-3xl md:text-4xl font-bold text-text-main mb-4'>
            Join <span className='text-accent'>TheChamps</span> app today
          </h2>
          <p className='text-lg text-gray-300 max-w-2xl mx-auto'>
            Choose the plan that works best for you and start your fitness
            journey today
          </p>
        </div>

        <div className='grid md:grid-cols-2 gap-8 max-w-4xl mx-auto'>
          {/* Annual Plan */}
          <div className='bg-secondary rounded-2xl shadow-lg border-2 border-accent overflow-hidden relative'>
            {/* Best Value Tag */}
            <div className='absolute top-0 right-0 bg-accent text-text-inverted text-sm font-bold py-1 px-4 rounded-bl-lg'>
              Best Value
            </div>

            <div className='p-8'>
              <h3 className='text-2xl font-bold text-text-main mb-2'>
                1-Year Access
              </h3>
              <div className='flex items-baseline mb-4'>
                <span className='text-4xl font-bold text-text-main'>$6.75</span>
                <span className='text-gray-400 ml-2'>/month</span>
              </div>
              <div className='flex items-center mb-6'>
                <p className='text-gray-300'>
                  <span className='line-through text-gray-500'>$9/month</span>{' '}
                  <span className='text-accent font-semibold'>Save 25%</span>
                </p>
              </div>
              <p className='text-gray-300 mb-6 font-bold'>
                Total <span className='text-accent'>$81</span>
              </p>

              <ul className='space-y-3 mb-8'>
                {offers.map((offer, index) => (
                  <li
                    className='flex items-start'
                    key={index}
                  >
                    <CheckIcon />
                    <span>{offer}</span>
                  </li>
                ))}
                {/* <li className='flex items-start'>
                  <CheckIcon />
                  <span>Full refund within 7-day cancellation</span>
                </li> */}
              </ul>
            </div>
          </div>

          {/* Monthly Plan */}
          <div className='bg-secondary rounded-2xl shadow-lg border-2 border-border-dark overflow-hidden relative'>
            {/* Popular Tag */}
            <div className='absolute top-0 right-0 bg-subaccent text-text-inverted text-sm font-bold py-1 px-4 rounded-bl-lg'>
              Popular
            </div>

            <div className='p-8'>
              <h3 className='text-2xl font-bold text-text-main mb-2'>
                3-Month Access
              </h3>
              <div className='flex items-baseline mb-4'>
                <span className='text-4xl font-bold text-text-main'>$9</span>
                <span className='text-gray-400 ml-2'>/month</span>
              </div>
              <div className='flex items-center mb-6'>
                <p className='text-gray-300'>
                  <span className='text-gray-300 font-bold'>
                    Total <span className='text-accent'>$27</span>
                  </span>
                </p>
              </div>
              <p className='text-gray-300 mb-6'>
                Cancel or change your plan anytime
              </p>

              <ul className='space-y-3 mb-8'>
                {offers.map((offer, index) => (
                  <li
                    className='flex items-start'
                    key={index}
                  >
                    <CheckIcon />
                    <span>{offer}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <button
        className='flex items-center justify-center bg-yellow-500 hover:bg-yellow-600 text-black font-bold py-3 px-6 sm:px-8 rounded-full text-base sm:text-lg transition-all duration-300 transform hover:scale-105 mt-10 mx-auto'
        onClick={() => (window.location.href = 'https://thechamps.app')}
      >
        Start Your First 9DAYS
      </button>
    </section>
  );
};

export default Price;
